import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { Dashboard_Client_Report } from "../../../Configuration/API_URL";
import SmallLoader from "../../../Components/Common/smallLoader";
import { Constants } from "../../../CommonMethhods/Constants";
import Loader from "../../../Components/Common/Loader";
import TodateComponent from "../../Reports/TodateComponent";
import FromdateComponent from "../../Reports/FromdateComponent";
import { toast } from "react-toastify";
import CostReportTable from "../../../Components/ReportTables/CostReportTable";
import DurationChangeComponent from "../../Reports/DurationChangeComponent";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function CostReportTradeNew() {
  const storeToken = localStorage.getItem("ssoToken");
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [errorGrid, setErrorGrid] = useState(false);
  const [seg, setSeg] = useState("stocks");
  const [customShow, setCustomShow] = useState(false)
  const [totalValues, setTotalValues] = useState({
    totalBrokerage: 0,
    totalGst: 0,
    totalSecTxnTax: 0,
    totalStampDuty: 0,
    totalSebiFees: 0,
    totalTxnChrg: 0,
    totalOthrChrg: 0,
    totalChrg: 0,
    totalIpftCharge: 0,
  });
  const ClientId2 = localStorage.getItem("ClientId2");

  if (fromDate === "" || toDate === "") {
    // const current = new Date();
    // const CurrentYear = current.getFullYear();
    // const CurrentMonth = current.getMonth();
    // if (CurrentMonth < 4) {
    //   const newYear = `04-01-${CurrentYear - 1}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // } else {
    //   const newYear = `04-01-${CurrentYear}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // }
    let date = new Date();
    let firstDay = "";
    let lastDay = "";
    let firstVal = new Date(date.getFullYear(), date.getMonth(), 1);
    firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");
    let lastVal = new Date();
    lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
    setFromDate(firstDay)
    setToDate(lastDay)
  }
  let clientCode = "";

  const getCostReport = async (fileView) => {
    if (fileView === "excel") {
      setSmallLoaderExcel(true);
    }
    if (fileView === "pdf") {
      setSmallLoaderPdf(true);
    }
    if (fileView === "mail") {
      setSmallLoaderMail(true);
    }
    if (fileView === "grid") {
      setLoader(true);
    }
    let payloadValue = {
      clientCode: clientCode || ClientId2,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileView,
      seg: seg,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.CostReportTrade_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if (fileView === "grid") {
          setTotalValues({
            totalBrokerage: res?.data?.totalBrokerage,
            totalGst: res?.data?.totalGst,
            totalSecTxnTax: res?.data?.totalSecTxnTax,
            totalStampDuty: res?.data?.totalStampDuty,
            totalSebiFees: res?.data?.totalSebiFees,
            totalTxnChrg: res?.data?.totalTxnChrg,
            totalOthrChrg: res?.data?.totalOthrChrg,
            totalChrg: res?.data?.totalChrg,
            totalIpftCharge: res?.data?.totalIpftCharge,
          });
          if (seg === "stocks" || seg === "com") {
            setData(res?.data?.eq);
          } else {
            setData(res?.data?.fo);
          }
        } else if (fileView === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileView === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        } else {
          toast.success("Mail sent successfully");
        }
      } else {
        setData([]);
        setTotalValues({});
        if (fileView !== "grid") {
          toast.error(res?.message);
        } else {
          setErrorGrid(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);
      if (fileView !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
    }
  };

  const handleFromDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setError(false);
    setErrorGrid(false);
    setData([]);
    setServerError(false);
  };

  const handleToDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setErrorGrid(false);
    setError(false);
    setData([]);
    setServerError(false);
  };

  useEffect(() => {
    if (localStorage.getItem("clientCode") || ClientId2) {
      clientCode = localStorage.getItem("clientCode");
      if (
        compareDate(fromDate) &&
        compareDate(toDate) &&
        checkDateRange(fromDate, toDate)
      ) {
        getCostReport("grid", clientCode);
      } else {
        setData([]);
      }
    }
  }, []);
  const onChangeDuration = () => {
    setErrorGrid(false);
    setError(false);
    setData([]);
    setServerError(false);
  }
  const handleOnClick = (e) => {
    if (localStorage.getItem("clientCode") || ClientId2) {
      clientCode = localStorage.getItem("clientCode");
      if (fromDate.length > 0 && toDate.length > 0) {
        if (e.target.value) {
          if (
            compareDate(fromDate) &&
            compareDate(toDate) &&
            checkDateRange(fromDate, toDate)
          ) {
            getCostReport(e.target.value, clientCode);
            setError(false);
          } else {
            setError("Please Select Correct Date.");
          }
        }
      }
    }
  };

  const handleSegmentChange = (e) => {
    setData([]);
    setErrorGrid(false);
    setSeg(e.target.value);
    setServerError(false);
  };

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }
  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="tax-report"
        role="tabpanel"
        aria-labelledby="tax-report"
      >
        <div className="reports-date-filter">
          <div className="reports-left-form">
            <form>

              <div className="report-form-wrapper">
                <div className="form-group">
                  <DurationChangeComponent
                    setCustomShow={setCustomShow}
                    setFromDate={setFromDate}
                    setToDate={setToDate}
                    onChangeDuration={onChangeDuration}
                    className="report-custom-select"
                     screen="Client Dashboard"
                  />
                </div>
                {customShow && <FromdateComponent
                  fromDate={handleFromDateChange}
                  formatDate={formatDate(fromDate)}
                  DateReverse={DateReverse}
                />}

                {customShow && <TodateComponent
                  toDate={handleToDateChange}
                  formatToDate={formatDate(toDate)}
                  DateReverse={DateReverse}
                  errorResponse={error}
                />}
              </div>

              <div className="form-group">
                <label className="form-label">Segment:</label>
                <select
                  className="report-custom-select"
                  onChange={handleSegmentChange}
                >
                  <option value="stocks">Equity</option>
                  <option value="fo">Derivative</option>
                  <option value="com">Commodity</option>
                  <option value="slbm">SLBM</option>
                </select>
              </div>

            </form>
            <button
              className="generate-button get-data"
              value="grid"
              onClick={handleOnClick}
            >
              {/* <span class="icon-pdfsvg"></span> */}

              {Constants.Submit}
            </button>
          </div>
          <div className="report-btn-wrapper">
            <button
              className="generate-button mail-btn"
              value="mail"
              onClick={handleOnClick}
            >
              {smallLoaderMail ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-email"></span>
                  E-Mail
                </>
              )}
            </button>
            <button
              value="excel"
              onClick={handleOnClick}
              className="generate-button excel-btn"
            >
              {smallLoaderExcel ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {Constants.Excel}
                </>
              )}
            </button>
            <button
              className="generate-button pdf-btn"
              value="pdf"
              onClick={handleOnClick}
            >
              {smallLoaderPdf ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-pdfsvg"></span>
                  {Constants.PDF}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
      {loader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : data && data.length > 0 ? (
        <div>
          <CostReportTable data={data} totalValues={totalValues} seg={seg}/>
        </div>
      ) : serverError ? (
        <h4 className="report-error-message">{noDataFound(serverError)}</h4>
      ) : errorGrid ? (
        noDataFound(errorGrid)
      ) : (
        ""
      )}
    </>
  );
}
export default CostReportTradeNew;
